/**
 * To use i18n outside of components.
 *
 * Only works if invoked after createI18n() in plugins/vue-plugins/i18n.ts
 * See: https://vue-i18n.intlify.dev/guide/advanced/composition#global-scope
 */
import type { AppI18n } from '~/plugins/vue-plugins/i18n'

export default function useI18nGlobal(): AppI18n['global'] | { t: AppI18n['global']['t'] } {
  if (window.__i18n__?.global) {
    return window.__i18n__.global
  }
  console.warn('[i18n]: global i18n missing')
  return {
    t: (...args: unknown[]): string => args.map(String).join(''),
  }
}
